// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mWu5","label":"styles_label__3P9aL"};